<template>
    <Form as="" :validation-schema="schema" v-slot="{ meta, handleSubmit }">
        <bs5-base-modal :title="$t('clients.editTitle')" :visible="visible" @close="closeModal">
            <template v-slot:default>
                <form novalidate @submit.prevent="handleSubmit($event, updateClient)">
                    <bs5-form-field id="editClientName" name="name" :label="$t('common.name')" v-model="client.name" />
                    <bs5-form-field id="editClientDescription" name="description" :label="$t('common.description')"
                        v-model="client.description" />
                    <button type="submit" class="d-none" tabindex="-1" aria-hidden="true"></button>
                </form>
            </template>

            <template v-slot:footer>
                <bs5-cancel-button @click="closeModal" />
                <bs5-save-button :loading="saving" :disabled="!meta.valid" @click="handleSubmit($event, updateClient)">
                    <i class="bi bi-check2"></i>{{ $t("common.save") }}
                </bs5-save-button>
            </template>
        </bs5-base-modal>
    </Form>
</template>

<script lang="ts">
import { t } from "@/helpers/i18n";
import { defineComponent } from "vue";
import { Form } from "vee-validate";
import * as yup from "yup";
import clientService from "@/services/client.service";
import { Client } from "@/models/client.model";
import { showToast } from "@/utils/toast";
import { nameMaxLength, optionalText, requiredText } from "@/utils/validation";

export default defineComponent({
    components: { Form },
    computed: {
        schema() {
            return yup.object({
                name: requiredText(nameMaxLength),
                description: optionalText(),
            });
        },
    },
    name: "EditClientModal",
    props: {
        visible: { type: Boolean, required: true },
        clientId: { type: String, required: true },
    },
    emits: ["close", "client-updated"],
    data() {
        return {
            client: { id: "", name: "", description: "", distributorId: "" } as Client,
            saving: false,
        };
    },
    watch: {
        clientId: {
            immediate: true,
            handler(newId: string) {
                if (newId) {
                    this.fetchClient();
                }
            },
        },
    },
    methods: {
        async fetchClient() {
            try {
                this.client = await clientService.getClientById(this.clientId);
            } catch (error) {
                console.error("Error fetching client:", error);
            }
        },
        async updateClient() {
            this.saving = true;
            try {
                await clientService.updateClient(this.client.id as string, { ...this.client });
                this.$emit("client-updated");
                this.closeModal();
                showToast(t("clients.updated"), "success");
            } catch (error) {
                showToast(t("clients.updateFailed"), "error");
            } finally {
                this.saving = false;
            }
        },
        closeModal() {
            this.$emit("close");
        },
    },
});
</script>
